export default __webpack_public_path__ + "static/media/DSC_7793.bfda496e.jpg";